export default {
  "nav.brand": "USFANSLINK",
  "nav.home": "Accueil",
  "nav.guide": "Guide complet",
  "nav.shoppingGuide": "Guide d'achat",
  "nav.visitMain": "Visiter le site principal",

  "hero.eyebrow": "Ressource du spreadsheet USFANS",
  "hero.title": "USFANS Spreadsheet — Trouvez produits, vendeurs et ressources d'achat plus vite",
  "hero.subtitle": "Vous cherchez le spreadsheet USFANS ? Explorez des ressources produits organisées, des infos sur les vendeurs, des guides d'achat, des conseils de contrôle qualité, des infos de livraison, des ressources d'entrepôt et les dernières actualités USFANS — le tout au même endroit.",
  "hero.ctaPrimary": "usfans spreadsheet",
  "hero.ctaSecondary": "buy it now",
  "hero.trust": "Ressource informative indépendante • Mise à jour régulièrement • Conçue pour faciliter la recherche de produits",

  "dropdown.label": "Parcourir les catégories",
  "dropdown.placeholder": "Choisissez une catégorie…",

  "categories.title": "Acheter par catégorie",
  "categories.subtitle": "Accédez directement à chaque catégorie de produits du site principal. Chaque lien s'ouvre dans un nouvel onglet.",
  "categories.shoes": "Chaussures",
  "categories.hoodies": "Hoodies / Pulls",
  "categories.tshirts": "T-shirts",
  "categories.jackets": "Vestes",
  "categories.pants": "Pantalons / Shorts",
  "categories.headwear": "Couvre-chefs",
  "categories.sets": "Ensembles",
  "categories.underwear": "Sous-vêtements / Caleçons",
  "categories.jersey": "Maillots",
  "categories.accessories": "Accessoires",
  "categories.bags": "Sacs",
  "categories.belts": "Ceintures",
  "categories.perfumes": "Parfums",
  "categories.other": "Autres articles",
  "categories.open": "Ouvrir",

  "features.title": "Tout ce qu'il faut pour naviguer dans le spreadsheet USFANS",
  "features.subtitle": "Une ressource organisée qui vous aide à passer de l'exploration à une décision sûre.",
  "features.f1.title": "Trouvez des produits plus vite",
  "features.f1.text": "Découvrez des ressources produits et catégories organisées sans perdre de temps à chercher dans des informations éparpillées.",
  "features.f2.title": "Comparez les vendeurs",
  "features.f2.text": "Apprenez ce qu'il faut vérifier pour évaluer les vendeurs, les infos produits et les ressources disponibles.",
  "features.f3.title": "Comprenez la livraison",
  "features.f3.text": "Explorez les infos de livraison USFANS, les coûts, les méthodes et les points importants avant de commander.",
  "features.f4.title": "Vérifiez avant d'acheter",
  "features.f4.text": "Utilisez les guides de contrôle qualité, d'entrepôt, de sécurité et d'achat pour mieux décider.",

  "teaser.eyebrow": "Guide à la une",
  "teaser.title": "Le guide complet du spreadsheet USFANS",
  "teaser.text": "Découvrez ce qu'est le spreadsheet USFANS, comment l'utiliser et ce qu'il faut vérifier avant d'acheter — de la recherche de vendeurs à la livraison, au contrôle qualité et à la sécurité.",
  "teaser.cta": "Lire le guide complet",

  "faq.title": "FAQ du spreadsheet USFANS",
  "faq.q1": "Qu'est-ce que le spreadsheet USFANS ?",
  "faq.a1": "C'est une ressource organisée qui regroupe catégories de produits, notes sur les vendeurs et infos d'achat dans une seule liste structurée, pour explorer les produits plus vite au lieu de chercher page par page.",
  "faq.q2": "Comment utiliser le spreadsheet USFANS ?",
  "faq.a2": "Commencez par la catégorie dont vous avez besoin, lisez les notes sur le vendeur, comparez quelques options, vérifiez la livraison puis ouvrez le lien produit dans un nouvel onglet pour continuer sur le site principal.",
  "faq.q3": "USFANS est-il légitime ?",
  "faq.a3": "Nous sommes une ressource indépendante et ne pouvons pas vérifier chaque vendeur ou produit. Vérifiez toujours vous-même les infos, les avis et les conditions de livraison avant d'acheter.",
  "faq.q4": "Combien coûte la livraison USFANS ?",
  "faq.a4": "Les frais de livraison varient selon la destination, le poids et la méthode ; nous ne publions donc pas de prix fixes ici. Vérifiez les infos de livraison actuelles sur le site principal avant de commander.",

  "cta.title": "Prêt à explorer le spreadsheet USFANS ?",
  "cta.text": "Commencez par le hub du spreadsheet, explorez les derniers guides et comparez les ressources utiles avant de visiter le site principal.",
  "cta.primary": "Explorer le spreadsheet USFANS",
  "cta.secondary": "Lire le guide",

  "footer.disclaimerTitle": "Avertissement",
  "footer.disclaimer": "Ce site web est une ressource informative indépendante. Nous ne garantissons ni les vendeurs, ni les produits, ni les résultats de livraison, ni les remboursements, ni les transactions, ni les délais. Vérifiez toujours les informations actuelles avant d'acheter.",
  "footer.explore": "Explorer",
  "footer.company": "Entreprise",
  "footer.guide": "Guide complet",
  "footer.rights": "Tous droits réservés.",
  "footer.language": "Langue",

  "guides.title": "Guides et ressources USFANS",
  "guides.subtitle": "Des guides indépendants et originaux pour rechercher des produits, comparer les vendeurs et acheter en confiance.",
  "guides.readMore": "Lire le guide",
  "article.notFound": "Guide introuvable",

  "nav.about": "À propos",
  "nav.contact": "Contact",
  "nav.privacy": "Politique de confidentialité",
  "nav.editorial": "Politique éditoriale",

  "contact.title": "Contactez-nous",
  "contact.subtitle": "Une question ou un retour ? Envoyez-nous un message et nous vous répondrons.",
  "contact.name": "Nom",
  "contact.email": "E-mail",
  "contact.message": "Message",
  "contact.submit": "Envoyer le message",
  "contact.sending": "Envoi en cours...",
  "contact.success": "Merci ! Votre message a bien été envoyé.",
  "contact.error": "Une erreur est survenue. Veuillez réessayer.",

  "article.reviewedBy": "Relu par",
  "article.lastUpdated": "Dernière mise à jour",

  "notFound.title": "Page introuvable",
  "notFound.text": "La page que vous recherchez n'existe pas ou a été déplacée.",
};